import { Checkbox, Grid, Typography } from '@material-ui/core'
import { getApprovalValues } from 'ducks/selectors'
import { useSelector } from 'react-redux'
import useStyles from './styles'
import { FC } from 'react'
import { useStepperContext } from 'hooks/useStepperContext'

export interface ContactConsentProps {}

const ContactConsent: FC<ContactConsentProps> = () => {
  const classes = useStyles()
  const { showWarnings, saveNewValue } = useStepperContext()

  const { smsConsent } = useSelector(getApprovalValues())

  return (
    <Grid container direction="column" style={{ gap: '16px' }}>
      <Grid item>
        <Typography className={classes.title} style={{ marginBottom: 0 }}>
          📱 contact consent
        </Typography>
      </Grid>
      <Grid
        container
        item
        className={classes.consent}
        style={{
          width: '100%',
          borderColor:
            showWarnings && !smsConsent
              ? 'var(--border-border-error-light)'
              : '#99DDBD',
        }}
      >
        <Checkbox
          checked={smsConsent}
          onChange={() => saveNewValue('smsConsent', !smsConsent)}
          name="consent"
          color="primary"
          style={{
            color: showWarnings && !smsConsent ? 'red' : 'primary',
            padding: 0,
            height: '24px',
          }}
        />
        <Typography className={classes.consentText}>
          💬 📲 I consent to receive SMS messages from BOSSCAT regarding the
          project.
        </Typography>
      </Grid>
    </Grid>
  )
}

export default ContactConsent
